import { useContext, useRef } from "react";
import { AppContext } from "../App";
import { post } from "./api";
import Label from "./Label";

function Form() {
	const { reservation, order, vote, setVote, setVoted, mode } = useContext(AppContext);
	const message = useRef();

	const handleForm = async () => {
		if (mode == "reservation") {
			const response = await post("/reservations/edit/" + reservation.id + "/", {
				review: vote,
				review_message: message.current.value,
			});
		} else {
			const response = await post("/orders/edit/" + order.id + "/", {
				review: vote,
				review_message: message.current.value,
			});
		}
		setVoted(true);
	};

	return (
		<div className="form">
			<textarea ref={message} required></textarea>
			<button onClick={handleForm}>
				<Label number={7} />
			</button>
			<button onClick={() => setVote(false)} className="secondary">
				<Label number={10} />
			</button>
		</div>
	);
}

export default Form;
